import 'gatsby-plugin-breadcrumb/gatsby-plugin-breadcrumb.css';

type GatsbyLoader = {
  hovering: (...args: unknown[]) => void;
  enqueue: (...args: unknown[]) => { abort: () => void } | void;
};

type WindowWithLoader = Window & {
  ___loader?: GatsbyLoader;
};

// Disable aggressive prefetching
export const disableCorePrefetching = () => true;

export const onClientEntry = () => {
  if (typeof window !== 'undefined' && (window as WindowWithLoader).___loader) {
    const loader = (window as WindowWithLoader).___loader as GatsbyLoader;
    loader.hovering = () => {};
    loader.enqueue = () => ({ abort: () => {} });
  }
};

// Optionally, add custom prefetch logic with throttling
export const onRouteUpdate = () => {
  // Delay prefetch to reduce concurrent requests
  setTimeout(() => {
    const prefetchLinks = document.querySelectorAll('link[rel="prefetch"]');
    prefetchLinks.forEach((link, index) => {
      // Remove most prefetch links to reduce load
      if (index > 5) {
        // Keep only first 5
        link.remove();
      }
    });
  }, 1000);
};
